const IntroMessage = ({continuePressed}) => {
    return (
        <div style={{
            width: '40%',
            margin: '0 auto',
            textAlign: 'left',
          }}>
          
            <p>Hello And Welcome!</p>
          
            <p>This website was created to test reinforcement learning applied to generating sheet music practice.</p>
          
            <p>When you click continue, you will see sheet music and a play button. Click play to hear four clicks on the metronome and then hear the music.</p>
          
            <p></p>
          
            <p>Next, you will be challenged to play along with the music matching the pitch and rhythm with your computer keyboard. You will hear four clicks on the metronome again and then should play along with the sheet music to completion. A reference keyboard is provided at the bottom of the challenge screen to show key mappings.</p>
          
            <p>You will receive an accuracy score and a log of your played note vs the correct played note at 100 ms timesteps.</p>
          
            <p>Refresh your page to get a new challenge. The system should adjust over time to give you challenges where you score around 80%.</p>
          
            <p>
              By clicking <b>CONTINUE</b> you consent to have the music events recorded in the model training.
            </p>
          
            <p>
              We keep track of your progress through cookies, so please don't clear site cookies. We do not store any personal information.
            </p>
          
            <p 
              onClick={() => continuePressed()}
              style={{ cursor: 'pointer', fontWeight: 'bold', color: 'blue' }}
            >
              CONTINUE
            </p>
          </div>
    )
}

export default IntroMessage